import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import VueScroll from "vuescroll/dist/vuescroll-native";
import QRCode from "qrcodejs2";
import codeMirror from "codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/python/python";
@Component({
    name: "AiShare",
    components: {
        VueScroll
    }
})
export default class AiShare extends Vue {
    @Prop({}) readonly shareData!: any;
    private ops: any = {
        vuescroll: {
            mode: "native"
        },
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "#F2F2F2"
        }
    };
    mounted() {
        this.$nextTick(() => {
            //@ts-ignore
            this.editor = codeMirror.fromTextArea(this.$refs.mycode, {
                mode: "python",
                lineNumbers: true,
                readOnly: "nocursor"
            });
            new QRCode(this.$refs["QR"], this.shareData.codeUrl);
        });
    }
    @Emit()
    closeShare(flag) {
        return flag;
    }
}

//@ts-ignore
export { default as AiShare } from "./index.vue";
